<canvas #canvasElement class="w-full h-full block"></canvas>
